const PAYHERO_API_URL   = 'https://backend.payhero.co.ke/api/v2/payments';
const PAYHERO_STATUS_URL = 'https://backend.payhero.co.ke/api/v2/transaction-status';
const AUTH_TOKEN        = 'Basic U1FVZW93M1pBbXlwclNZNFljaWg6OUJ2OUh3V0ZTVXI2bjIxRVlXbWgxbndxWWJPdWk1ZHRSV1R0Y3ZBTg==';
const CHANNEL_ID        = 6434;

// Initiate STK Push — returns { success, data, reference }
export async function initiateSTKPush(phoneNumber, amount, reference) {
  const phone = String(phoneNumber)
    .replace(/\s+/g, '')
    .replace(/^\+/, '')
    .replace(/^0/, '254');

  const payload = {
    amount:             Number(amount),
    phone_number:       phone,
    channel_id:         CHANNEL_ID,
    provider:           'm-pesa',
    external_reference: reference,
    customer_name:      'Lend Pesa Customer',
    callback_url:       'https://quickchapaaupgraded.web.app/callback',
  };

  try {
    const response = await fetch(PAYHERO_API_URL, {
      method:  'POST',
      headers: {
        'Content-Type':  'application/json',
        'Authorization': AUTH_TOKEN,
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    // STK push initiated — does NOT mean paid yet
    return { initiated: response.ok, data, reference };
  } catch (error) {
    return { initiated: false, error: error.message };
  }
}

// Poll Payhero to check if the payment was actually completed
// Returns 'SUCCESS' | 'FAILED' | 'PENDING' | 'CANCELLED'
export async function checkPaymentStatus(reference) {
  try {
    const response = await fetch(
      `${PAYHERO_STATUS_URL}?reference=${encodeURIComponent(reference)}`,
      {
        method:  'GET',
        headers: { 'Authorization': AUTH_TOKEN },
      }
    );
    const data = await response.json();
    // Payhero returns status field: SUCCESS, FAILED, PENDING, QUEUED, CANCELLED
    const status = (data?.status || data?.transaction_status || '').toUpperCase();
    if (status === 'SUCCESS') return 'SUCCESS';
    if (status === 'FAILED' || status === 'CANCELLED' || status === 'REJECTED') return 'FAILED';
    return 'PENDING';
  } catch (e) {
    return 'PENDING'; // network error — assume still pending
  }
}

// Poll with retries — waits up to maxWaitMs for payment confirmation
// Returns true if confirmed paid, false if failed/timeout
export async function waitForPaymentConfirmation(reference, maxWaitMs = 60000) {
  const interval  = 4000;  // check every 4 seconds
  const maxChecks = Math.ceil(maxWaitMs / interval);

  for (let i = 0; i < maxChecks; i++) {
    await new Promise(r => setTimeout(r, interval));
    const status = await checkPaymentStatus(reference);
    if (status === 'SUCCESS')  return { paid: true,  status };
    if (status === 'FAILED')   return { paid: false, status };
    // PENDING — keep polling
  }
  return { paid: false, status: 'TIMEOUT' };
}
